import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../data/data.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-cart-coupon',
    template: `
    <form [formGroup]="form" (submit)="addCouponCode()">
      <div class="modal-header">
        <h4 class="modal-title" i18n>Gutschein</h4>
        <button type="button" class="btn-close" aria-label="Close" i18n-aria-label
                (click)="activeModal.close()"></button>
      </div>
      <div class="modal-body">
        <div class="my-3 row">
          <label class="col-12 col-lg-4 col-form-label" i18n>Gutscheincode</label>
          <div class="col-12 col-lg-8">
            <input type="text" ngbAutofocus class="form-control" [formControl]="couponControl">
          </div>
        </div>
      </div>
      <div
        class="modal-footer justify-content-center align-items-center justify-content-md-between flex-column-reverse flex-md-row p-3 p-md-4">
        <button type="button" class="btn btn-lg btn-danger w-100 w-md-auto mb-3 mb-md-0"
                (click)="removeCouponCode()" i18n [disabled]="loading" [appLoadingOverlay]="loading">Löschen
        </button>
        <button type="submit" class="btn btn-lg btn-info w-100 w-md-auto" i18n
                [disabled]="loading || couponControl.invalid" [appLoadingOverlay]="loading">Änderungen
          speichern
        </button>
      </div>
    </form>
  `,
    standalone: false
})
export class CouponModalComponent {
  couponControl = new UntypedFormControl(null, [Validators.required]);
  form = new UntypedFormGroup({
    couponCode: this.couponControl,
  });
  loading = false;

  constructor(public activeModal: NgbActiveModal,
              private readonly dataService: DataService) {

    this.couponControl.setValue(dataService.cart?.coupon?.code);
  }

  async addCouponCode() {
    if (!this.form.valid) {
      return;
    }

    this.loading = true;

    try {
      await this.dataService.updateCartCoupon(this.couponControl.value);
      this.activeModal.close();
    } finally {
      this.loading = false;
    }
  }

  async removeCouponCode() {
    const NO_COUPON = '';
    this.loading = true;
    try {
      await this.dataService.updateCartCoupon(NO_COUPON);
      this.activeModal.close();
    } finally {
      this.loading = false;
    }
  }
}
